import { LocalImage } from '../../primitives';
import { styled } from '../../theme';

export const iconSize = {
	xs: 8,
	sm: 12,
	md: 16,
	lg: 18,
	xl: 26,
	xxl: 32,
	xxxl: 42,
};

// TODO: Remove "Icon"-prefix since its stupid.
export const iconPaths = {
	IconAccordionMinusGreen: 'assets/icons/accordion-minus/green.svg',
	IconAccordionPlusGreen: 'assets/icons/accordion-plus/green.svg',
	IconAnnouncementWhite: 'assets/icons/announcement/white.svg',
	IconArrowDownBlack: 'assets/icons/arrow-down/black.svg',
	IconArrowDownGreen: 'assets/icons/arrow-down/green.svg',
	IconArrowDownOrange: 'assets/icons/arrow-down/orange.svg',
	IconArrowDownWhite: 'assets/icons/arrow-down/white.svg',
	IconArrowLeftGray: 'assets/icons/arrow-left/gray.svg',
	IconArrowLeftGreen: 'assets/icons/arrow-left/green.svg',
	IconArrowLeftWhite: 'assets/icons/arrow-left/white.svg',
	IconArrowRightGray: 'assets/icons/arrow-right/gray.svg',
	IconArrowRightWhite: 'assets/icons/arrow-right/white.svg',
	IconBankIdNegative: 'assets/icons/bankid/negative.svg',
	IconBankIdNormal: 'assets/icons/bankid/normal.svg',
	IconBellGray: 'assets/icons/bell/gray.svg',
	IconBellGreen: 'assets/icons/bell/green.svg',
	IconBellWhite: 'assets/icons/bell/white.svg',
	IconCheckboxCheckedGray: 'assets/icons/checkbox-checked/gray.svg',
	IconCheckboxCheckedGreen: 'assets/icons/checkbox-checked/green.svg',
	IconCheckboxGreen: 'assets/icons/checkbox/green.svg',
	IconCheckboxLineGray: 'assets/icons/checkbox-line/gray.svg',
	IconCogGray: 'assets/icons/cog/gray.svg',
	IconCogGreen: 'assets/icons/cog/green.svg',
	IconCrossGray: 'assets/icons/cross/gray.svg',
	IconCrossWhite: 'assets/icons/cross/white.svg',
	IconFacebookCircleWhite: 'assets/icons/facebook-circle/white.svg',
	IconFacebookMessengerWhite: 'assets/icons/facebook-messenger/white.svg',
	IconFacebookWhite: 'assets/icons/facebook/white.svg',
	IconHeartFilledGreen: 'assets/icons/heart-filled/green.svg',
	IconHeartFilledRed: 'assets/icons/heart-filled/red.svg',
	IconHeartGray: 'assets/icons/heart/gray.svg',
	IconHeartGreen: 'assets/icons/heart/green.svg',
	IconHeartRed: 'assets/icons/heart/red.svg',
	IconHeartWhite: 'assets/icons/heart/white.svg',
	IconInfoGreen: 'assets/icons/info/green.svg',
	IconInfoGreenSm: 'assets/icons/info/green-sm.svg',
	IconInfoWhite: 'assets/icons/info/white.svg',
	IconInfoWhiteSm: 'assets/icons/info/white-sm.svg',
	IconInstagramCircleWhite: 'assets/icons/instagram-circle/white.svg',
	IconPigWhite: 'assets/icons/pig/white.svg',
	IconRingBellWhite: 'assets/icons/ring-bell/white.svg',
	IconSearchGray: 'assets/icons/search/gray.svg',
	IconSearchWhite: 'assets/icons/search/white.svg',
	IconSearchGreen: 'assets/icons/search/green.svg',
	IconSearchThickGray: 'assets/icons/search-thick/gray.svg',
	IconSearchThickGreen: 'assets/icons/search-thick/green.svg',
	IconSupportWhite: 'assets/icons/support/white.svg',
	IconTimerBlack: 'assets/icons/timer/black.svg',
	IconUserGray: 'assets/icons/user/gray.svg',
	IconMyBonusGreen: 'assets/icons/mybonus-b/green.svg',
	IconMyBonusGray: 'assets/icons/mybonus-b/gray.svg',
};

export type IconProps = {
	name: keyof typeof iconPaths;
	size?: keyof typeof iconSize;
	className?: string;
};

function Base(props: IconProps) {
	return <LocalImage uri={`/${iconPaths[props.name]}`} className={props.className} />;
}

export const Icon = styled(Base)`
	height: ${(props) => iconSize[props.size || 'md']}px;
`;
